import { useApolloClient } from "@apollo/client";
import type { TypedDocumentNode } from "@graphql-typed-document-node/core";
import type { DocumentNode } from "graphql/index";
import { isNotNil } from "ramda-adjunct";
import { useMemo } from "react";

/**
 * A utility hook that retrieves data entities by fragment and id.
 *
 * @template TData The type of data returned for each entity.
 *
 */
export const useOptionsByValues = <TData,>(props: {
  values: string[];
  fragment: DocumentNode | TypedDocumentNode<TData>;
}): TData[] => {
  const client = useApolloClient();

  return useMemo(
    () =>
      props.values
        .map((id) => {
          try {
            return client.readFragment({
              id: id,
              fragment: props.fragment,
            });
          } catch (error) {
            console.error(error);
            // Entity not in cache
            return null;
          }
        })
        .filter(isNotNil),
    [props.values, props.fragment, client]
  );
};
